import { render } from "./Room.vue?vue&type=template&id=e34683c6&bindings={\"room\":\"props\",\"measure\":\"props\",\"shouldBeCentered\":\"data\",\"clickHandler\":\"options\",\"rightClickHandler\":\"options\",\"doubleClickHandler\":\"options\",\"resize\":\"options\",\"ident\":\"options\",\"name\":\"options\",\"styleObject\":\"options\",\"foregroundStyles\":\"options\"}"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"

import "./Room.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script